export const StepList = [
  "Background",
  "Requirements",
  "Goals",
  "Benifits",
  "Submit",
];
